module.exports = __webpack_public_path__ + "img/zgwd.3f3b1bbd.jpg";